import {
  ActiveConnector,
  Connector,
  StepperContainer,
  StepperList,
  Step,
  StepButton,
  StepLabel,
} from './styles';

type StepperProps = {
  currentStep: number;
  steps: (string | undefined)[];
  editMode?: boolean;
  skippedSteps?: number[];
  onClick?: (step: number) => void;
};

export type StepperStatus = 'done' | 'current' | 'todo' | 'skipped';

const getStepStatus = (
  index: number,
  currentStep: number,
  editMode: boolean,
  skippedSteps?: number[],
): StepperStatus => {
  if (index === currentStep) {
    return 'current';
  }

  if (skippedSteps && skippedSteps.includes(index)) {
    return 'skipped';
  }
  if (editMode && index !== currentStep) {
    return 'done';
  }

  if (index < currentStep) {
    return 'done';
  }

  return 'todo';
};

export const Stepper = ({ currentStep, steps, editMode, skippedSteps, onClick }: StepperProps) => {
  const handleStepClick = (step: number) => {
    onClick?.(step);
  };

  return (
    <StepperContainer>
      <StepperList>
        <Connector steps={steps.length}>
          <ActiveConnector currentStep={currentStep} steps={steps.length} />
        </Connector>
        {steps.map((step, index) => {
          const status = getStepStatus(index, currentStep, !!editMode, skippedSteps);
          const stepNumber = index + 1;

          return (
            <Step key={`${step}-${stepNumber}`}>
              <StepButton
                status={status}
                onClick={() => {
                  handleStepClick(stepNumber);
                }}
                disabled={!onClick}
              ></StepButton>
              {step && <StepLabel status={status}>{step}</StepLabel>}
            </Step>
          );
        })}
      </StepperList>
    </StepperContainer>
  );
};
